import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class SignRiskFormError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('SignRiskFormError', ...args);
    }
}
export default SignRiskFormError;
